module.exports = __webpack_public_path__ + "img/sonjaaugustin.d9210c70.jpeg";